import { combineReducers } from 'redux';
import {
  SET_PARAMS,
  ANALYZE_FUNDS,
  CLEAR_FUNDS,
  CLEAR_FUND,
  SHOW_OR_HIDE_WT_FUNDS,
  SHOW_CAPGAINS_OR_PERF,
  OPEN_EXTERNAL_LINK_MODAL,
  CLOSE_EXTERNAL_LINK_MODAL,
  LOAD_PORTFOLIO,
  CLEAR_SELECTED_FUNDS,
} from '../actions/actions';

import { LOAD_HISTORY } from '../actions/list-portfolios.js';

// default data state
export const initData = {
  'fundsToCompare': [],
  'showWTFunds': true,
  'fundListType': 'capgains'
};

// fundData reducer
const fundData = (state = {}, action) => {
  switch (action.type) {
    case ANALYZE_FUNDS:

      console.log(action.payload);

      if (action.payload === undefined || action.payload.length === 0) {
        return state;
      }

      if (typeof(action.payload)=== 'string'){
        return {
          ...state,
          loadingMessage: action.payload
        }
      }

      const fundList = [];

      // Find the full fund suggestion object for each selected fund
      action.payload.forEach(function (item, index) {

        // var found = state.fundSuggestions.find(function (element) {
        //   return element.externalID === item.inputFund.externalID;
        // });

        var alreadyInList = state.fundsToCompare.find(function (element) {
          return element.inputFund.externalID === item.inputFund.externalID;
        });

        if (alreadyInList === undefined) {
          fundList.push(item);
        }

      });

      return {
        ...state,
        fundsToCompare: fundList.concat(state.fundsToCompare),
        loadingMessage: null
      }

    case CLEAR_FUNDS:
      // Clear out the fundsToCompare
      return Object.assign({}, state, {
        fundsToCompare: []
      });

    case CLEAR_SELECTED_FUNDS:
        // Clear out the selectedFunds
        return Object.assign({}, state, {
          selectedFunds: null
        });

    case CLEAR_FUND:

      const externalID = action.payload;
      const funds = state.fundsToCompare.filter(function (element) {
        return (
          element.inputFund.externalID !== externalID
        )
      });

      // Clear out a single fund, given by the index
      return Object.assign({}, state, {
        fundsToCompare: funds
      });

    case SHOW_OR_HIDE_WT_FUNDS:

      // Clear out a single fund, given by the index
      return Object.assign({}, state, {
        showWTFunds: action.payload
      });

    case SHOW_CAPGAINS_OR_PERF:

      // Clear out a single fund, given by the index
      return Object.assign({}, state, {
        fundListType: action.payload
      });

    case OPEN_EXTERNAL_LINK_MODAL:

      // Save the URL for the external Modal popout
      return Object.assign({}, state, {
        externalModalURL: action.payload
      });

    case CLOSE_EXTERNAL_LINK_MODAL:

      // Save the URL for the external Modal popout
      return Object.assign({}, state, {
        externalModalURL: null
      });

    case LOAD_PORTFOLIO:
      if ( !action.portfolio || !action.portfolio.holdings || action.portfolio.holdings.length === 0) {
        return state;
      }

      var selected_funds = [];
      var holding = action.portfolio.holdings[0];

      // Loop over the funds in the holdings object and assign to the selected funds
      for (var i=0; i < holding.tickers.length; i++) {

        // Check if an excel result is already in the FundList
        var alreadyInList = state.fundsToCompare.find(function (element) {
          return element.ticker === holding.tickers[i];
        });

        if (alreadyInList === undefined) {
          selected_funds.push({ 'value': holding.cusips[i], 'label': holding.names[i] + " (" + holding.tickers[i] + ")" });
        }

      };

      // return new state with updated history results
      return Object.assign({}, state, {
        selectedFunds: selected_funds.length > 0 ? selected_funds : null
      });


    default:
      return state;

  }
};

// main reducer for history (from DPD)
const history = (state = {}, action) => {

  switch (action.type) {
    case LOAD_HISTORY:
      return Object.assign({}, state, {
        portfolios: action.data
      });

    default:
      return state;
  }
}

// default params state
export const initParams = {
  'wtRegion': ''
};

// params reducer
const params = (state = {}, action) => {
  switch (action.type) {
    case SET_PARAMS:
      return Object.assign({}, state, {
        wtRegion: action.payload
      });
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  fundData,
  params,
  history
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/reducers.js